import {Helmet} from "react-helmet-async";
import bookingFlowTitle from '../../assets/images/BookingFlowTitle.png';
import step1 from '../../assets/images/bookingSteps/step1.png';
import React, {useEffect, useState} from "react";
import s from './BookingProcess.module.scss';
import ImageWithPlaceholder from "../../components/Image/ImageWithPlaceholder";
import BookingSteps from "./BookingSteps";


const BookingProcess = () => {
    const [steps, setSteps] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchSteps = async () => {
            try {
                setLoading(true);

                const res = await fetch(`${process.env.REACT_APP_API_URL}/api/booking-steps`);

                if (!res.ok) throw new Error("Failed to fetch");

                const data = await res.json();

                setSteps(data); // adjust if response structure different

            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchSteps();
    }, []);

    return (
        <>
            <Helmet>
                <title>予約方法に迷ったら確認してね</title>
                <meta property="og:title" content="予約方法に迷ったら確認してね"/>
                <meta property="og:image" content={`${process.env.REACT_APP_URL}/og-image.png`}/>
                <meta property="og:url" content={`${process.env.REACT_APP_URL}/howto`}/>
                <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！"/>
                <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！"/>
                <meta property="og:type" content="article"/>

            </Helmet>
            <div className={"row mt-5"}>
                <div className={"col-12"}>
                    <div className={s.titleWrrapper}>
                        <img className={s.titleImage} src={bookingFlowTitle} alt="予約方法に迷ったら確認してね"/>
                    </div>

                </div>
            </div>
            <div className={"row mt-5"}>
                <div className={"col-12"}>

                    {steps && steps.map((step, index) => (
                        <BookingSteps
                            key={index}
                            index={index}
                            step={step}
                            total={steps.length}
                        />
                    ))}


                </div>
            </div>
        </>
    )
}
export default BookingProcess